import request from '@/utils/request'
const apiPath = '/sys/sysExpress'
const sysGoodsServiceApi = {
  /**
   * 新增【快递配置】
   */
  create(data) {
    return request.post(apiPath + '/tee/save', data)
  },
  /**
   * 修改【快递配置】
   */
  update(data) {
    return request.put(apiPath + '/tee/update', data)
  },
  /**
   * 分页查询【快递配置】
   */
  fetchList(query) {
    return request.get(apiPath+'/tee/list', { params: query })
  },
  /**
   * 查询【快递配置】选项列表
   */
  findOptions(query) {
    return request.get(`${apiPath}/options`, { params: query })
  },
  /**
   * 查看【快递配置】详情
   */
  fetchById(id) {
    return request.get(`${apiPath}/${id}`)
  },
  /**
   * 删除单个【快递配置】
   */
  deleteById(id) {
    return request.delete(`${apiPath}/${id}`)
  },
  /**
   * 批量删除【快递配置】
   */
  deleteBatch(ids) {
    return request.delete(apiPath, { data: ids })
  },
  setIsEnableExpress(data) {
    return request.put(apiPath + '/tee/setIsEnable', data)
  },
}
export default sysGoodsServiceApi
